<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px]"
          >
            <div class="max-h-[92px] w-full flex flex-col items-center">
              <component
                v-if="icon"
                :is="icon"
                class="w-[50px] h-[50px] text-primary"
              />
              <span class="PC_Body1-SB !text-[#1F1D1F] h-[24px]">
                {{ label }}
              </span>
              <span v-if="name" class="PC_caption-R !text-[#1F1D1F]">
                {{ name }}
              </span>
            </div>
            <SelectBoxComponent
              :inputId="'formShelterID'"
              :searchable="true"
              :allowEmpty="true"
              :keyValue="'id'"
              :keyName="'name'"
              :options="AllShelterTransfer"
              :value="form.shelter_id"
              :label="'สู่ศูนย์พักพิง'"
              :placeholder="'เลือกศูนย์พักพิง'"
              :warningMessage="errors.shelter_id"
              :hideValues="[form.hideShelter_id]"
              @update:modelValue="
                (res) => {
                  form.shelter_id = res;
                }
              "
            />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="labelConfirmButton"
                :bClass="'btn_shadow--save'"
                :disabled="form.shelter_id == ''"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script setup>
import { ref } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { usePopulationStore } from "@/pinia/population";
import { useShelterStore } from "@/pinia/shelter";
import { storeToRefs } from "pinia";

const props = defineProps({
  icon: {
    type: String,
    default: "TransferIcon",
  },
  label: { type: String, default: "โอนย้ายผู้ประสบภัย" },
  labelConfirmButton: { type: String, default: "บันทึก" },
});

const { $validateMsg } = useGlobals();
const populationStore = usePopulationStore();
const shelterStore = useShelterStore();
const { AllShelterTransfer } = storeToRefs(shelterStore);
const input = {
  id: "",
  shelter_id: "",
  hideShelter_id: "", // ใช้ซ่อน shelter ปัจจุบัน
};
const form = ref({ ...input });
const errors = ref({ ...input });
const name = ref("");
const modalIsOpened = ref(false);

const openModal = (data, shelterId, username) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  console.log("data", data);
  form.value = {
    ...input,
  };
  errors.value = {
    ...input,
  };
  form.value.id = data.id;
  if (shelterId) {
    // form.value.shelter_id = shelterId;
    form.value.hideShelter_id = shelterId;
  } else if (username) {
    name.value = username;
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const emit = defineEmits(["success"]);

const save = async () => {
  await populationStore
    .transferPopulation(form.value.id, form.value)
    .then((response) => {
      if (response.status === 200) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style scoped>
</style>